<template>
  <div class="bg-white grow px-2">
    <div class="h-full flex flex-col">
      <div class="h-12 flex items-center justify-between">
        <div class="flex flex-row">
          <div class="flex items-center ml-1">
            <span v-if="innerPerms.export" class="text-sm group hover:bg-gray-100 mr-1">
              <span class="flex justify-between items-center" @click="handleExport">
                <i class="bi bi-box-arrow-up mr-1" />
                <span class="mx-auto">导出</span>
                <i class="bi bi-caret-down-fill text-xs invisible group-hover:visible" />
              </span>
            </span>
            <span
              v-if="innerPerms.delete" :class="{'opacity-50': multipleSelection.length === 0}"
              class="text-sm group hover:bg-gray-100 mr-1" @click="handleRemove"
            >
              <span class="flex justify-between items-center cursor-pointer">
                <i class="bi bi-trash mr-1" />
                <span class="mx-auto">删除</span>
              </span>
            </span>
          </div>
        </div>
        <div class="text-xl flex items-center">
          <el-popover
            placement="bottom-end"
            width="350"
          >
            <button slot="reference"><i class="bi bi-filter mx-1" /></button>
            <div>
              筛选出符合以下
              <el-select v-model="filter.rel" style="width: 65px;" class="simple">
                <el-option label="所有" value="and" />
                <el-option label="任一" value="or" />
              </el-select>
              条件的数据
            </div>
            <div>
              <el-popover
                v-model="menuVisible"
                placement="bottom-start"
                width="200"
                :append-to-body="false"
                popper-class="popper-class"
              >
                <div>
                  <el-menu v-if="menuVisible" @select="handleSelect">
                    <el-menu-item
                      v-for="widget in tableData.header" :key="widget.name" :index="widget.name"
                      style="height: 32px;line-height: 32px;"
                    >
                      {{ widget.text }}
                    </el-menu-item>
                  </el-menu>
                </div>
                <span slot="reference" class="cursor-pointer text-sky-500 text-sm h-9 leading-9">
                  <i class="bi bi-plus text-base" />
                  添加条件
                </span>
              </el-popover>
            </div>
            <ul class="field-list">
              <li v-for="(item, index) in filter.cond" :key="index" class="field-item main-field group">
                <div
                  class="field-label relative  h-10 w-full flex flex-row items-center justify-between group-hover:bg-[#ebf8fb] px-2"
                >
                  <div class="grow flex flex-row items-center ">
                    <div class="w-1/3 field-name overflow-hidden truncate">
                      {{ item.name }}
                    </div>
                    <div class="w-1/3">
                      <el-select v-model="item.method" class="simple">
                        <el-option value="eq" label="等于" />
                        <el-option value="neq" label="不等于" />
                        <el-option value="empty" label="为空" />
                        <el-option value="not-empty" label="不为空" />
                      </el-select>
                    </div>
                  </div>

                  <div class="w-10">
                    <i
                      class="bi bi-trash mx-1 cursor-pointer"
                      @click="() => {filter.cond.splice(index, 1)}"
                    />
                  </div>
                </div>
                <div
                  v-if="item.method === 'eq' || item.method === 'neq'"
                  class="w-full group-hover:bg-[#ebf8fb] px-2 pb-1"
                >
                  <el-date-picker
                    v-if="item.type==='date'"
                    v-model="item.value[0]"
                    type="month"
                    size="small"
                    value-format="yyyy-MM"
                  />
                  <el-select v-else-if="item.type === 'dept'" v-model="item.value[0]" filterable size="small" remote @focus="handleFilterRemoteMethod($event,item.field)">
                    <el-option
                      v-for="(_item, _index) in options[item.field]"
                      :key="_index"
                      :label="_item.label"
                      :value="_item.value"
                    />
                  </el-select>
                  <el-input v-else v-model="item.value[0]" size="small" />
                </div>
              </li>
            </ul>
            <div class="border-t flex items-center pt-3">
              <el-button type="primary" size="small" @click="handleFilter">筛选</el-button>
              <el-button size="small" @click="handleClearFilter">清空</el-button>
            </div>
          </el-popover>
          <button @click="handleRefresh"><i class="bi bi-arrow-repeat mx-1" /></button>
        </div>
      </div>
      <div class="grow h-0 overflow-auto border">
        <el-table
          :key="tableData.key"
          v-fit-columns
          v-loading="loading"
          border
          :data="tableData.data"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
          />
          <template v-for="(header,index) in tableData.header">
            <el-table-column v-if="header.type === 'upload'" :key="index" :label="header.text">
              <template slot-scope="scope">
                <span v-for="(_file, _index) in scope.row[header.name]" :key="_index" class="mx-1"><el-link
                  :href="_file['url']"
                >{{ _file['name'] }}</el-link></span>
              </template>
            </el-table-column>
            <el-table-column v-else :key="index" :prop="header.name" :label="header.text" />
          </template>
        </el-table>
      </div>
      <div class="h-10">
        <el-pagination
          :current-page="query.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="query.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import zroute from '../ziggy'

const defaultPerms = {
  batch_print: false,
  batch_update: false,
  copy: false,
  create: false,
  delete: false,
  export: false,
  import: false,
  read: false,
  update: false,
}
export default {
  name: 'AuthManage',
  props: {
    perms: {
      type: Object,
      default: () => ({}),
    },
    authGroupId: {
      type: Number,
    },
  },
  data() {
    return {
      menuVisible: false,
      widgetList: [],
      innerPerms: {...defaultPerms, ...this.perms},
      loading: false,
      app_id: zroute().params.app_id,
      form_id: zroute().params.form_id,
      tableData: {data: [], header: [], total: 0, key: Date.now()},
      query: {
        authGroupId: this.authGroupId,
        fields: [],
        filter: {cond: [], rel: 'and'},
        sort: [],
        page: 1,
        size: 20,
      },
      options: {},
      filter: {cond: [], rel: 'and'},
      multipleSelection: [],
    }
  },
  watch: {
    // query: {
    //   handler(val) {
    //     this.findData()
    //   },
    //   deep: true,
    // },
  },
  created() {
    this.findData()
  },
  methods: {
    handleFilterRemoteMethod(event, field) {
      console.log('handleFilterRemoteMethod', event, field)
      if (this.options[field]) {
        return
      }
      axios.post(zroute('app.data.distinct'), {
        appId: this.app_id,
        formId: this.form_id,
        field: field,
        authGroupId: this.authGroupId,
      }).then(res => {
        this.$set(this.options, field, res.data.data)
        // this.options[field] = res.data.data
      })
    },
    handleClearFilter() {
      this.filter = {cond: [], rel: 'and'}
      this.query.filter = this.filter
      this.findData()
    },
    handleFilter() {
      this.query.filter = {
        cond: this.filter.cond.map(item => {
          return {
            field: item.field,
            method: item.method,
            value: item.value,
          }
        }), rel: this.filter.rel,
      }
      this.findData()
    },
    handleRemove() {
      if (this.multipleSelection.length === 0) {
        return
      }
      this.$confirm('确定删除选中的记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        console.log('handleRemove', this.multipleSelection)
        axios.post(zroute('app.data.remove'), {
          appId: this.app_id,
          formId: this.form_id,
          idList: this.multipleSelection.map(item => item.id),
          authGroupId: this.authGroupId,
        }).then(res => {
          this.multipleSelection = []
          this.handleRefresh()
        })
      })

    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleRefresh() {
      this.query.page = 1
      this.findData()
    },
    handleSizeChange(val) {
      this.query.size = val
      this.findData()

    },
    handleCurrentChange(val) {
      this.query.page = val
      this.findData()

    },
    findData() {
      this.loading = true
      axios.post(zroute('app.form.find', [this.app_id, this.form_id]), this.query).then(res => {
        this.tableData = {...res.data.data, key: Date.now()}
        this.loading = false
        console.log(this.tableData)
      })
    },
    handleExport() {
      axios.post(zroute('app.data.excel_export'), {
        appId: this.app_id,
        formId: this.form_id,
        authGroupId: this.authGroupId,
      }).then(res => {
        window.open(res.data.url)
      })
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath)
      let widget = this.tableData.header.find(item => item.name === key)
      this.filter.cond.push({
        field: key,
        name: widget.text,
        method: 'eq',
        type: widget.type,
        value: [],
      })
      this.menuVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .popper-class {
  .el-menu {
    max-height: 300px;
    overflow: auto;
  }
}
</style>
